import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { toast } from "react-toastify";
import { connectWithGoogle } from "api/authService";

export const useGoogleFitLogin = (onSuccessCallback) => {
  const login = useGoogleLogin({
    flow: "auth-code",
    scope: [
      "https://www.googleapis.com/auth/fitness.activity.read",
      "https://www.googleapis.com/auth/fitness.body.read",
      "https://www.googleapis.com/auth/fitness.location.read",
      "https://www.googleapis.com/auth/fitness.sleep.read",
      "https://www.googleapis.com/auth/fitness.heart_rate.read",
      "https://www.googleapis.com/auth/fitness.blood_pressure.read",
      "https://www.googleapis.com/auth/userinfo.profile",
      "email",
      "openid",
    ].join(" "),
    onSuccess: async (codeResponse) => {
      try {
        console.log("✅ Google Auth Code:", codeResponse.code);

        // toast.info("Google Fit linked successfully!");

        if (onSuccessCallback) onSuccessCallback(codeResponse);
      } catch (error) {
        console.error("❌ Error sending code to backend:", error);
        toast.error("Google login failed. Please try again.");
      }
    },
    onError: (error) => {
      console.error("❌ Google OAuth error:", error);
      toast.error("Google authentication failed.");
    },
  });

  return login;
};
